export default __webpack_public_path__ + "static/media/2305.f5effbc7.png";